import styles from './StepIndicator.module.scss';
import { Props } from './StepIndicator.types';

const StepIndicator = ({ index }: Props) => {
  return <div className={styles.index}>{index}</div>;
};

export default StepIndicator;
